import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import PopupFiles from './PopupFiles'
import PopupNewSupplier from './PopupNewSupplier'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns';
import { loadOneProduct } from '../../../../store/Actions/ActionProducts'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'

function IndexDetailsProduct() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { one_product, loadingOneProduct } = useSelectorCustom()
    const { translate } = AbstructLang()
    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    let { id } = useParams()
    useEffect(() => {
        dispatch(loadOneProduct(id))
    }, [])

    return (
        <>
            <main>
                <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                    {
                        loadingOneProduct ? (
                            <InnerLoader />
                        ) : <div className='div_details_warehouse' >
                            <div>
                                <h3>{translate('Basic_material_information')}</h3>
                                <div className='row_details' >
                                    <div>
                                        <span className='title' >{translate('name')}</span>
                                        <span>{one_product?.name}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('category')}</span>
                                        <span>{one_product?.material_category?.name}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('sub_categories')}</span>
                                        <span>{one_product?.material_sub_category?.name}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('warehouses')}</span>
                                        <span>{one_product?.warehouse?.name}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('type')}</span>
                                        <span>{one_product?.type}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('brand')}</span>
                                        <span>{one_product?.brand}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('model')}</span>
                                        <span>{one_product?.model}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('serial_number')}</span>
                                        <span>{one_product?.sn}</span>
                                    </div>
                                    <div>
                                        <span className='title' >{translate('status')}</span>
                                        <span>{one_product?.status}</span>
                                    </div>
                                    <div>
                                        <div className={`files_pro`} onClick={() => setOpen(true)}  >
                                            <i className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} fa fa-file`} ></i>
                                            <span>{translate('files')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='row_details' style={{ marginTop: "0px" }} >
                                    <div className='row_details_div50' >
                                        <span className='title' >{translate('description')}</span>
                                        <span>{one_product?.description}</span>
                                    </div>
                                    <div className='row_details_div50' >
                                        <span className='title' >{translate('notes')}</span>
                                        <span>{one_product?.notes}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
                {
                    loadingOneProduct ? (<></>) :
                        <>
                            <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                                <div className='div_details_warehouse' style={{ marginTop: "10px" }} >
                                    <h3>{translate('material_descriptions')}</h3>
                                    {
                                        one_product?.descriptions?.map((i) => {
                                            return (
                                                <div className='row_details' >
                                                    <div>
                                                        <span className='title' >{translate('name')}</span>
                                                        <span>{i?.name}</span>
                                                    </div>
                                                    <div className='row_details_div72' >
                                                        <span className='title' >{translate('description')}</span>
                                                        <span>{i?.description}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                            {/*<div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                                <div className='div_details_warehouse' style={{ marginTop: "10px" }} >
                                    <div className='div_supplier1' >
                                        <h2>{translate('material_supplier_details')}</h2>
                                    </div>
                                    <div className='row_details' >
                                        {
                                            one_product && one_product?.suppliers_details && (
                                                <>
                                                    <div>
                                                        <span className='title' >{translate('qty')}</span>
                                                        <span>{one_product?.suppliers_details[0]?.qty}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('cost')}</span>
                                                        <span>{one_product?.suppliers_details[0]?.cost}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('currency')}</span>
                                                        <span>{one_product?.suppliers_details[0]?.currency}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('date_of_supply')}</span>
                                                        <span> {format(new Date(one_product?.suppliers_details[0]?.date_of_supply), 'dd-MM-yyyy')}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('time_of_supply')}</span>
                                                        <span> {format(new Date(one_product?.suppliers_details[0]?.time_of_supply), 'HH:mm:ss')}</span>
                                                    </div>
                                                    <div>
                                                        <span className='title' >{translate('place_of_supply')}</span>
                                                        <span>{one_product?.suppliers_details[0]?.place_of_supply}</span>
                                                    </div>
                                                    <div className='row_details_div72' >
                                                        <span className='title' >{translate('reason_of_supply')}</span>
                                                        <span>{one_product?.suppliers_details[0]?.reason_of_supply}</span>
                                                    </div>
                                                </>
                                            )
                                        }

                                    </div>
                                </div>
                            </div>*/}
                        </>
                }

            </main>
            {
                open && (
                    <PopupFiles files={one_product?.files} open={open} setOpen={setOpen} />
                )
            }
            {
                open2 && (
                    <PopupNewSupplier open={open2} setOpen={setOpen2} />
                )
            }
        </>
    )
}

export default IndexDetailsProduct